import { FormControl, FormLabel } from "@chakra-ui/react";
import React from "react";
import type { FieldError } from "react-hook-form";
import { observer } from "mobx-react";
import { FormFieldError } from "./FormFieldError";
import { stripColon } from "@/helpers/string";
import { useStore } from "@/store";

interface Props {
  label: string;
  error?: FieldError | string;
  isError?: boolean;
  children: React.ReactNode;
}

interface ErrorTextProps {
  label: string;
  error?: FieldError | string;
}

const ErrorText = observer(({ error, label }: ErrorTextProps) => {
  const { getErrorInputText } = useStore();

  if (!error) return null;

  let errorMessage = typeof error === "string" ? error : error.message;

  if (!errorMessage) errorMessage = getErrorInputText(label);

  return <FormFieldError error={errorMessage} />;
});

export const FormGroup = ({ label, error, isError, children }: Props) => {
  const strippedLabel = stripColon(label);
  const errorColor = "primary-light";
  const finalIsError = error || isError;

  return (
    <FormControl>
      <FormLabel color={finalIsError ? errorColor : undefined}>
        {label}
      </FormLabel>
      {children}
      <ErrorText
        error={error}
        label={strippedLabel}
      />
    </FormControl>
  );
};
